import React from "react";
import SubmenuLayoutOne from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_One";
import SubmenuLayoutTwo from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Two";
import SubmenuLayoutThree from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Three";
import SubmenuLayoutFour from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Four";
import SubmenuLayoutFive from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Five";
import SubmenuLayoutSeven from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Seven";
import SubmenuLayoutEight from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Eight";
import SubmenuLayoutNine from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Nine";
import SubmenuLayoutTen from "@qlik/qlik/src/components/Header/Dropdowns/layouts/Submenu_Layout_Ten";
import { LAYOUT_LINK_ONLY } from "@qlik/qlik/src/lib/constants/menu-layout-names";

// For the "Layout - Link Only" menu option - where there are no 3rd level menus
const emptyMenuWrapper = () => <div></div>;
/**
 * TODO: consider merging this into LevelThreeMenu and passing deviceType
 */
const LevelThreeMenuMobile = ({ data, layoutType, layoutId }) => {
    const { subItems, itemName } = data || {};

    const menuLayoutMapping = {
        "Layout - Why Qlik": SubmenuLayoutOne,
        "Layout - Technology Partners": SubmenuLayoutTwo,
        "Layout - Data Integration": SubmenuLayoutThree,
        "Layout - All Products": SubmenuLayoutFour,
        "Layout - By Industry": SubmenuLayoutFive,
        "Layout - By Role": SubmenuLayoutSeven,
        "Layout - Topics and Trends": SubmenuLayoutEight,
        "Layout - Glossary": SubmenuLayoutNine,
        "Layout - Community": SubmenuLayoutTen,
        [LAYOUT_LINK_ONLY]: emptyMenuWrapper,
    };

    const Layout = menuLayoutMapping[itemName];

    return Layout ? <Layout data={subItems} layoutType={layoutType} layoutId={layoutId} deviceType="mobile" /> : null;
};

export default LevelThreeMenuMobile;
